module.exports = __webpack_public_path__ + "img/small_Dab bagienny (25).20fc4485.png";